module.exports = __webpack_public_path__ + "static/media/megameios.2cc7e4b8.jpg";